// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/_vant@2.12.54@vant/lib/index.css
// module id = 859
// module chunks = 41